module.exports = __webpack_public_path__ + "3c8db08e87bc4d796113eb6f6c9546ed.png";